import React from 'react';
import styled from 'styled-components';

import { useTheme } from 'hooks';
import { Logo } from 'assets';
import { RingLoader } from 'components/partials';
import LanguageSelection from './container/language-selection/language-selection';

const HeaderNode = styled.header`
  width: 100%;
  margin: 0 auto;
  height: 7rem;
`;

const Row1 = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`;

const Row1Col1 = styled.div`
  width: 50%;
`;

const Row1Col2 = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 50%;
`;

const Row2 = styled.div`
  left: 0;
  right: 0;
  top: 1.188rem;
  position: absolute;
  width: 100%;
`;

const LoaderWrapper = styled.div`
  width: 100%;
  margin: 0.75rem auto;
`;

type HeaderPropTypes = {
  isLoading?: boolean;
};

export const Header: React.FC<HeaderPropTypes> = ({ isLoading }) => {
  const { styles } = useTheme();

  return (
    <HeaderNode>
      <Row1>
        <Row1Col1>
          <Logo />
        </Row1Col1>
        <Row1Col2>
          <LanguageSelection />
        </Row1Col2>
      </Row1>

      {isLoading && (
        <Row2>
          <LoaderWrapper>
            <RingLoader color="white" bgColor={styles.colorPrimaryButtonBackground} />
          </LoaderWrapper>
        </Row2>
      )}
    </HeaderNode>
  );
};

Header.defaultProps = {
  isLoading: false,
};
